import { DrawerProps } from 'components/Drawer/Root'
import Styles from './DesignDownloadDrawer.module.scss'
import { Button } from 'blaze-ui/Button'
import { Download, LinkAngled } from 'blaze-ui/icons'
import { DesignDownloadBody } from './DesignDownloadBody'
import { useDesignDownload } from './useDesignDownload'
import { DesignerDrawer } from 'components/Design/DesignerDrawer/DesignerDrawer'

const DesignDownloadDrawer = ({ fileId, ...props }: DrawerProps & { fileId?: string }) => {
  const { handleShare, handleSubmit, isDownloading, previews, exportFiles, handleSingleDownload, framesCount } =
    useDesignDownload({
      fileId,
    })

  return (
    <DesignerDrawer title="Export Design" initialSnap={1} padding="5px 15px 20px 15px" {...props}>
      <div className={Styles.content}>
        <div className={Styles.bodyContainer}>
          <DesignDownloadBody
            downloadsCount={framesCount}
            previews={previews}
            exportFiles={exportFiles}
            onPress={handleSingleDownload}
          />
        </div>
        {exportFiles.length > 0 && (
          <div className={Styles.buttons}>
            <Button
              size="lg"
              frontIcon={LinkAngled}
              variant="tertiary"
              onPress={handleShare}
              isDisabled={isDownloading}
            >
              Share Link
            </Button>
            <Button size="lg" frontIcon={Download} onPress={() => handleSubmit()} isDisabled={isDownloading}>
              {exportFiles.length === 1 ? 'Download' : `Download All ${exportFiles.length} Files`}
            </Button>
          </div>
        )}
      </div>
    </DesignerDrawer>
  )
}

export { DesignDownloadDrawer }
